export default __webpack_public_path__ + "static/media/goal.6a962db9.svg";